import React from 'react'

const Hero = () => {
    return (
        <section id="intro">   

            <div className="intro-overlay"></div>	

            <div className="intro-content" data-aos="flip-left">
                <div className="row">

                    <div className="col-twelve">

                        <h5>Hello, World.</h5>
                        <h1>I'm Mary Rojas</h1>

                        <p className="intro-position">
                            <span>Front-end UI Developer</span>
                        </p>

                        <a className="button stroke smoothscroll" href="#about" title="">More About Me</a>

                    </div>  
                    
                </div>   		 		
            </div>

            <ul className="intro-social">        
                <li><a href="https://www.linkedin.com/in/mcrojasp/"><i className="fa fa-linkedin"></i></a></li>
                <li><a href="https://www.behance.net/mcrojas"><i className="fa fa-behance"></i></a></li>
            </ul>    	

        </section>
    )
}

export default Hero
